"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverseEnum = exports.reverseMap = exports.getKfromV = void 0;
const getKfromV = (m, v) => Object.keys(m).find((k) => m[k] === v);
exports.getKfromV = getKfromV;
const reverseMap = (m) => Object.fromEntries(Object.entries(m).map(([k, v]) => [v, k]));
exports.reverseMap = reverseMap;
/** reverses numerical enum for use in dropdowns, perhaps */
const reverseEnum = (e) => Object.fromEntries(Object.entries(e)
    .filter(([k, v]) => typeof v === 'number')
    .map(([k, v]) => [v, k]));
exports.reverseEnum = reverseEnum;
